import  NetworkHandler from 'utils/network';
import config from 'config';
function upload(data) {
    return NetworkHandler.post(config.getUrl('upload','storage'), data);
}
export default {
    upload
};